// extracted by mini-css-extract-plugin
module.exports = {"card":"card-32yIf","sbp":"sbp-1Bwga"};